<template>
  <div class="d-flex-row space-between" v-if="selectedDifficulty">
    <p class="t-grey font-family-2 regular-l">
      <!-- {{ packSelectedOption.title }} -->
      {{ $t("new.difficulty") }}
    </p>
    <p class="t-white font-family-2 bold-l">
      <!-- {{ renderPrice(packSelectedOption) }} -->
      {{ selectedDifficulty.title }}
      <span class="t-blue bold-s"> {{ renderPrice(selectedDifficulty) }}</span>
    </p>
  </div>
</template>

<script setup>
import { calculateCurrency } from "~/calculate/calculatePrice";
const gameStore = useGameStore();
const userStore = useUserStore();

const checkoutStore = useCheckoutStore();

const selectedDifficulty = computed(() => {
  if (!checkoutStore.getDifficulty) return null;

  const diff = gameStore.getGamePack.pack_options?.find(
    (opt) => opt.id === checkoutStore.getDifficulty
  );

  return diff;
});

const renderPrice = (packOption) => {
  if (packOption.type === "free") {
    return "";
  } else if (packOption.type === "variable") {
    return `+${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `+${parseFloat(calculateCurrency(packOption.price)).toFixed(2)}${
      userStore.getUserCurrencyCode
    }`;
  } else {
    return `+${packOption.price}`;
  }
};
</script>
